import { formateInputNumber } from '@leprecoins/utility';
import { ElementProps, TagsInput, TagsInputProps } from '@mantine/core';
import { forwardRef, useState } from 'react';

export type TagsInputNumericProps = Omit<TagsInputProps, 'searchValue' | 'onSearchChange'> &
	ElementProps<'input', keyof TagsInputProps>;

export const TagsInputNumeric = forwardRef<HTMLInputElement, TagsInputNumericProps>(
	(props, ref) => {
		const [search, setSearch] = useState('');

		return (
			<TagsInput
				{...props}
				ref={ref}
				searchValue={search}
				onSearchChange={(v) => setSearch(formateInputNumber(v, null, null, false, 2))}
			/>
		);
	},
);
